import dayjs from 'dayjs';

export enum TimeUnit {
  minutes = 'minutes',
  hours = 'hours',
  days = 'days',
}

interface MaxDistance {
  value: number;
  unit: TimeUnit;
}

const translation: Record<TimeUnit, string> = {
  minutes: 'minutos',
  hours: 'horas',
  days: 'dias',
};

const useDateRangeValidator = () => {
  const validate = (
    dateFrom: Date | null,
    dateTo: Date | null,
    maxDistance?: MaxDistance
  ) => {
    if (!dateFrom || !dateTo) {
      return { isValid: false, error: 'Ambas fechas son obligatorias.' };
    }

    const from = dayjs(dateFrom);
    const to = dayjs(dateTo);

    if (from.isAfter(to)) {
      return {
        isValid: false,
        error: 'La fecha de inicio no puede ser posterior a la de fin.',
      };
    }

    if (maxDistance) {
      const diff = to.diff(from, maxDistance.unit);
      if (diff > maxDistance.value) {
        return {
          isValid: false,
          error: `La diferencia no puede ser mayor a ${maxDistance.value} ${translation[maxDistance.unit]}.`,
        };
      }
    }

    return { isValid: true, error: null };
  };

  return {
    validate,
  };
};

export default useDateRangeValidator;
